import { Typography } from '@iheartjane/reefer';
import { titleCase } from '@iheartjane/utils';

import { formatLabel } from '@jane/shared/util';

import { useProductCardContext } from '../productCardProvider';

export function ProductCategoryLabel() {
  const { menuProduct: product, store } = useProductCardContext();

  const lineageLabel = product?.category
    ? store?.custom_lineage_labels?.[product.category] || product.category
    : '';

  return (
    <Typography variant="small-body-regular" maxLines={1}>
      {lineageLabel ? (
        <span>
          {formatLabel(lineageLabel, ['CBD'])} {product?.kind}
        </span>
      ) : product?.kind ? (
        titleCase(product.kind)
      ) : null}
    </Typography>
  );
}
